import { useEffect } from 'react';

/**
 * Hook that handles iOS Safari viewport issues by setting a CSS variable
 * with the actual visual viewport height (accounting for toolbars)
 */
export function useVisualViewport() {
  useEffect(() => {
    const setViewportHeight = () => {
      // Use visualViewport if available (accounts for iOS Safari toolbar)
      const vh = window.visualViewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Set initial value
    setViewportHeight();

    // Listen to visualViewport resize (handles iOS Safari toolbar show/hide)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setViewportHeight);
      window.visualViewport.addEventListener('scroll', setViewportHeight);
    }

    // Fallback for browsers without visualViewport
    window.addEventListener('resize', setViewportHeight);

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', setViewportHeight);
        window.visualViewport.removeEventListener('scroll', setViewportHeight);
      }
      window.removeEventListener('resize', setViewportHeight);
    };
  }, []);
}
